/////////////////////////////////////////////////////
// Add your custom code here.
// This file and any changes you make to it are preserved every time the app is generated.
/////////////////////////////////////////////////////
import { Inject, Injector, Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { progress } from "@progress/jsdo-core";
import { SupplierDataDetailsViewBaseComponent } from "./supplier-data-details.view.base.component";
import { IntlService } from "@progress/kendo-angular-intl";
import { SortDescriptor, orderBy } from "@progress/kendo-data-query";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { TimeoutManagerService } from "../../../shared/services/timeout-manager.service";
import { CustomAuthorizationService } from "../../../core/auth/custom-authorization.service";
import { DomSanitizer } from "@angular/platform-browser";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { NotificationService } from "../../../core/notification/notification.service";
import { Notification } from "./../../../core/notification/notification";
import { TranslateService } from "@ngx-translate/core";

@Component({
    templateUrl: "./supplier-data-details.view.component.extended.html",
    styleUrls: ["./supplier-data-details.view.component.css"],
})
export class SupplierDataDetailsViewComponent extends SupplierDataDetailsViewBaseComponent {
    public sortChanges: SortDescriptor[] = [
        { field: "ChangeDate", dir: "desc" },
    ];
    public changesView: GridDataResult;
    public description: any;
    public prefixDescription: any;
    public overrideExtRefOpened: boolean = false;
    public declineRequestOpened: boolean = false;
    public overrideDialogOption: string = "";
    public expandedDetailKeys: any[] = [];
    public ttBookingChangeReasons: any;
    public ttSupplierBooking: any;
    public fileList: any[] = [];
    public showFiles = false;
    public fileUploadEnabled = "Forbidden";
    public DeclineComment: string = "";
    public isOnRequest: boolean = false;
    public declineRequestOneSegmentOpened: boolean = false;
    public declineOneSegmentComment: string = "";
    public selectedSegment: any;

    protected BookID: Number;
    protected BackendData: any;
    protected Changes: any;
    protected RoomCount: Number;
    protected GuestCount: Number;
    protected BookingInfo: any;
    protected jsdo: progress.data.JSDO;

    protected confirmingWithBookRef;
    protected confirmingSegmentId;
    protected confirmingWithUnitRef;

    private timeoutManagerService: TimeoutManagerService;
    private router: Router;

    private session: progress.data.JSDO;
    protected isLoading: boolean = true;
    public allowOnRequestDecision: boolean;
    private dsSupplierBookingDetail;

    constructor(
        @Inject(Injector) injector: Injector,
        @Inject(ActivatedRoute) protected route: ActivatedRoute,
        @Inject(IntlService) protected intl: IntlService,
        @Inject(CustomAuthorizationService)
        protected customAuthorizationService: CustomAuthorizationService,
        @Inject(DomSanitizer) protected domSanitizer: DomSanitizer,
        @Inject(Location) private location: Location,
        private http: HttpClient,
        private translateService: TranslateService,
    ) {
        super(injector);
        this.timeoutManagerService = injector.get(TimeoutManagerService);
        this.$notificationService = this.injector.get(NotificationService);
        this.router = injector.get(Router);
        this.initData();
        this.readData();
        // this.getFileList();
        this.getFiles();
        this.fileUploadEnabled =
            this.customAuthorizationService.uploadDocuments;

        Promise.all([
            this.customAuthorizationService.processAuthorizationResponse(),
        ]).then(() => {
            this.allowOnRequestDecision =
                this.customAuthorizationService.allowOnRequestDecision;
        });
        this.declineRequestOneSegment =
            this.declineRequestOneSegment.bind(this);
        this.approveRequestOneSegment =
            this.approveRequestOneSegment.bind(this);
    }

    // Fired when component is initialized and input properties are set
    public onInit(): void {
        // this.initHeaderPanel();
    }

    public getDescription(description: string) {
        if (description.includes(":")) {
            return description.split(":")[1];
        }

        return description;
    }

    public getPrefixDescription(description: string) {
        if (description.includes(":")) {
            return description.split(":")[0];
        }

        return "";
    }

    private initHeaderPanel() {
        const headerPanel = document.getElementById("headerPanel");
        const headerPanelOffset = headerPanel.offsetTop;
        window.onscroll = () => {
            if (window.pageYOffset > headerPanelOffset) {
                headerPanel.classList.add("sticky");
            } else {
                headerPanel.classList.remove("sticky");
            }
        };
    }

    // Fired when component's views and child views are initialized
    public onShow(): void {}
    // Fired just before Angular destroys the component. Unsubscribe Observables and detach event handlers to avoid memory leaks
    public onHide(): void {}

    private initData() {
        this.route.queryParams.forEach((params) => {
            // params.BookID
            this.BookID = parseInt(params.BookID);
            this.RoomCount = 0;
            this.GuestCount = 0;
            this.BookingInfo = {
                Duration: 0,
                SegmentBeginDate: new Date(),
                SegmentEndDate: new Date(),
            };

            this.session = new progress.data.JSDO(
                "SupplierBookingDetailBusinessEntity",
            );
            this.session.subscribe("afterFill", (jsdo, success, response) => {
                this.jsdo = jsdo;
                if (success) {
                    const dsSupplierBookingDetail = Object.assign(
                        {},
                        response.response.dsSupplierBookingDetail,
                    );

                    if (this.isSupplierBookingEmpty(dsSupplierBookingDetail)) {
                        this.router.navigate(["booking/supplier-data"]);
                        return;
                    }
                    this.BackendData = this.parseData(dsSupplierBookingDetail);
                    this.dsSupplierBookingDetail = dsSupplierBookingDetail;
                    this.Changes = dsSupplierBookingDetail.ttBookingChanges;
                    if (this.Changes !== null && this.Changes !== undefined) {
                        this.Changes.forEach((change) => {
                            change.ChangeDate = new Date(change.ChangeDate);
                            if (change.ConfirmationDate != null) {
                                change.ConfirmationDate = new Date(
                                    change.ConfirmationDate,
                                );
                            }
                        });
                        this.Changes = {
                            data: orderBy(this.Changes, this.sortChanges),
                            total: this.Changes.length,
                        };
                    }
                    if (dsSupplierBookingDetail.ttSupplierBooking)
                        this.ttSupplierBooking =
                            dsSupplierBookingDetail.ttSupplierBooking;
                    this.RoomCount =
                        dsSupplierBookingDetail.ttSupplierBooking.length;
                    this.GuestCount = dsSupplierBookingDetail.ttGuest.length;

                    if (dsSupplierBookingDetail.ttBookingChangeReasons)
                        this.ttBookingChangeReasons =
                            dsSupplierBookingDetail.ttBookingChangeReasons;

                    Object.assign(this.BookingInfo, this.BackendData[0]);
                    this.isOnRequest = this.isOnRequestStatus(this.BackendData);

                    //HARDCODED FOR TESTING PURPOSES
                    // this.BackendData[0].guests[0].ExtraInfo = "ala|bala|porto|cala|manman|pacpac";
                    // this.BackendData[0].guests[0].Preferences = "@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@";
                    // this.BackendData[0].guests[0].Discount = "ala|bala|porto|cala|manman|pacpac";
                    //  this.BackendData[0].discount = [
                    //      { Description: "Early bird - 10%" }
                    //  ];
                    //  this.BackendData[0].preference = [
                    //      { Description: "P: Smoking allowed;Quietly situated, gggdgg,ddddd" },
                    //      { Description: "E: Rooms next to each other; ffffsfff"},
                    //      { Description: "ME: Wheelchair ramp" }
                    //  ];
                    // this.BackendData[0].serviceInfo = [
                    //     { Description: "Massage service ALL INCLUSIVE" },
                    //     { Description: "Free sauna tickets"},
                    //     { Description: "VIP Guest - 24/7 escort service"}
                    // ];
                } else {
                    // console.log(response);
                    if (response.response.status_code === 401) {
                        this.timeoutManagerService.handleTimeout();
                    }
                }

                Promise.all([
                    this.customAuthorizationService.processAuthorizationResponse(),
                ]).then(() => {
                    this.isLoading = false;
                });
            });
        });
    }

    isOnRequestStatus(list: any[]): boolean {
        return list.some((item) => item.BookingStatus === "OnRequest");
    }

    protected readData() {
        this.isLoading = true;
        return this.session.fill({
            filter: JSON.stringify(this.filterData()),
        });
    }

    private isSupplierBookingEmpty(dsSupplierBookingDetail: any): boolean {
        return (
            !dsSupplierBookingDetail ||
            (this.isArrayNullOrEmpty(
                dsSupplierBookingDetail.ttBookingChanges,
            ) &&
                this.isArrayNullOrEmpty(
                    dsSupplierBookingDetail.ttSupplierBooking,
                ) &&
                this.isArrayNullOrEmpty(dsSupplierBookingDetail.ttGuest))
        );
    }

    private isArrayNullOrEmpty(array: any[]): boolean {
        return array === null || array === undefined || array.length === 0;
    }

    private parseData(dataset) {
        const elements = [];
        dataset.ttSupplierBooking.forEach((sup) => {
            const supplier = Object.assign({}, sup);
            supplier.guests = dataset.ttGuest.filter(
                (element) => element.SegmentID == supplier.SegmentID,
            );
            supplier.guests.forEach((element) => {
                element.BirthDate = new Date(element.BirthDate);
                let timezone = element.BirthDate.getTimezoneOffset();

                if (timezone > 0) {
                    let day = element.BirthDate.getDate();
                    let month = element.BirthDate.getMonth();
                    let year = element.BirthDate.getFullYear();
                    day = day + 1;
                    element.BirthDate = new Date(year, month, day);
                }
            });
            supplier.suppliercost = {};
            supplier.suppliercost.items =
                dataset.ttBookingCost &&
                !this.isArrayNullOrEmpty(
                    this.customAuthorizationService.checkAuthMethod(
                        "Bookings",
                        "BookingCosts",
                        "Display",
                    ),
                )
                    ? dataset.ttBookingCost.filter(
                          (element) => element.SegmentID == supplier.SegmentID,
                      )
                    : [];
            if (!this.isArrayNullOrEmpty(supplier.suppliercost.items)) {
                supplier.suppliercost.total = 0;
                supplier.suppliercost.items.forEach((element) => {
                    supplier.suppliercost.total += element.NetCost;
                });

                supplier.suppliercost.total =
                    Math.round(supplier.suppliercost.total * 100) / 100;
            }

            supplier.discount = dataset.ttDiscount
                ? dataset.ttDiscount.filter(
                      (element) => element.SegmentID == supplier.SegmentID,
                  )
                : [];
            supplier.serviceInfo = dataset.ttServiceInfo
                ? dataset.ttServiceInfo.filter(
                      (element) => element.SegmentID == supplier.SegmentID,
                  )
                : [];
            supplier.preference = dataset.ttPreference
                ? dataset.ttPreference.filter(
                      (element) => element.SegmentID == supplier.SegmentID,
                  )
                : [];

            supplier.acco = dataset.ttSegmAcco
                ? dataset.ttSegmAcco.find(
                      (element) => element.SegmentID === supplier.SegmentID,
                  )
                : null;
            supplier.verv = dataset.ttSegmVerv
                ? dataset.ttSegmVerv.find(
                      (element) => element.SegmentID === supplier.SegmentID,
                  )
                : null;
            supplier.odns = dataset.ttSegmOdns
                ? dataset.ttSegmOdns.find(
                      (element) => element.SegmentID === supplier.SegmentID,
                  )
                : null;

            //HARDCODED FOR TESTING PURPOSES
            // supplier.verv = {
            //     HopOffLocation: "statia de autobuz 123 autobuz 45 loc 23",
            //     HopOnLocation: "statia de autobuz 123 autobuz 45 loc 23",
            //     SegmentID: "403598-2-2",
            //     ServiceType: "BU",
            //     TransportDescription: "Zuid-Adriatische  - Zuid-Adriatisch - Tourist Class",
            // }

            supplier.SegmentBeginDate = new Date(supplier.SegmentBeginDate);
            supplier.SegmentEndDate = new Date(supplier.SegmentEndDate);

            let timezone = supplier.SegmentBeginDate.getTimezoneOffset();

            if (timezone > 0) {
                let day = supplier.SegmentBeginDate.getDate();
                let month = supplier.SegmentBeginDate.getMonth();
                let year = supplier.SegmentBeginDate.getFullYear();
                day = day + 1;
                supplier.SegmentBeginDate = new Date(year, month, day);

                day = supplier.SegmentEndDate.getDate();
                month = supplier.SegmentEndDate.getMonth();
                year = supplier.SegmentEndDate.getFullYear();
                day = day + 1;
                supplier.SegmentEndDate = new Date(year, month, day);
            }

            elements.push(supplier);
        });
        return elements;
    }

    private kendoFilterData() {
        return [
            {
                field: "BookID",
                operator: "eq",
                value: this.BookID,
            },
            {
                field: "Supplier",
                operator: "eq",
                value: sessionStorage.getItem("SupplierApp.supplierName"),
            },
        ];
    }

    private filterData() {
        return {
            dsFilter: {
                ttFilter: this.kendoFilterData(),
            },
        };
    }

    public printBooking() {
        window.print();
    }

    public backButton() {
        this.location.back();
    }

    public closeExtRefOverrideDialog(selectedOption: string) {
        this.overrideDialogOption = selectedOption;
        this.overrideExtRefOpened = false;
        this.confirmSelectedBookings();
    }

    public async confirmSelectedBookings() {
        try {
            if (this.overrideDialogOption === "NO") return;

            this.jsdo["ttSupplierBooking"].foreach((element) => {
                if (
                    !this.confirmingSegmentId ||
                    element.data.SegmentID === this.confirmingSegmentId
                ) {
                    if (
                        this.overrideDialogOption === "YES" ||
                        element.data.ExternalBookID === null ||
                        element.data.ExternalBookID === undefined ||
                        element.data.ExternalBookID === ""
                    )
                        element.assign({
                            ExternalBookID: this.confirmingWithBookRef,
                            SupplierConfirmed: this.confirmingWithBookRef,
                            UnitReference:
                                this.confirmingWithUnitRef !== ""
                                    ? this.confirmingWithUnitRef
                                    : element.UnitReference,
                        });
                }
            });

            this.isLoading = true;
            await this.jsdo.saveChanges(true);
            await this.readData();
        } catch (e) {
            this.isLoading = false;
            if (e.request.response.status_code === 401) {
                this.timeoutManagerService.handleTimeout();
            }
        }
    }

    public async confirmBooking(
        externalBookRef,
        segmentId,
        unitReference = "",
    ) {
        this.confirmingSegmentId = segmentId;
        this.confirmingWithBookRef = externalBookRef;
        this.confirmingWithUnitRef = unitReference;

        if (
            this.customAuthorizationService.isExternalBookRefMandatory &&
            (externalBookRef === undefined ||
                externalBookRef === null ||
                externalBookRef === "")
        ) {
            alert("Please fill the Booking ID");
            return;
        }

        /* If the user is changing a single segment or there are no segments that 
        already have an external booking ref set we don't need to show a dialog to
        the user */

        if (segmentId || !this.hasSegmentsWithExternalRef()) {
            this.overrideDialogOption = "YES";
            this.confirmSelectedBookings();
        } else this.overrideExtRefOpened = true;
    }

    public getSafeHtmlChanges(changes: string) {
        return this.domSanitizer.bypassSecurityTrustHtml(changes);
    }

    public expandDetailsBy = (dataItem: any): any => {
        return dataItem.ChangeDate;
    };

    protected hasSegmentsWithExternalRef(): boolean {
        let bookingSegmentsWithRef = this.jsdo["ttSupplierBooking"].find(
            (element) => {
                if (
                    element.data.ExternalBookID &&
                    element.data.ExternalBookID !== ""
                )
                    return true;
                else return false;
            },
        );

        if (bookingSegmentsWithRef) return true;
        else return false;
    }

    public getChangeReasons(BookingChangesId) {
        return this.ttBookingChangeReasons.filter(
            (el) => el.BookingChangesId === BookingChangesId,
        );
    }

    getFiles() {
        const url = `${
            environment.getDataProviders()["SupplierAppProvider"].serviceUri
        }/web/pdo/SupplierAppService/SupplierBookingDetailBusinessEntity/ReadTravelDocuments`;
        this.http
            .put(url, { filter: this.BookID }, { withCredentials: true })
            .subscribe((response) => {
                this.fileList =
                    response["response"]["dsTravelDocument"][
                        "dstravelDocument"
                    ]["ttTravelDocument"];
            });
    }

    getFileList() {
        const url = `${
            environment.getDataProviders()["SupplierAppProvider"].serviceUri
        }/web/pdo/SupplierAppService/FileManager/GetFileList`;
        this.http
            .put(url, { filter: this.BookID }, { withCredentials: true })
            .subscribe((response) => {
                this.fileList =
                    response["response"]["dsFileList"]["dsFileList"]["ttFile"];
            });
    }

    private readonly allowedTypes = [
        "application/pdf",
        "application/gpx+xml",
        "application/xml",
        "text/xml",
    ];

    private readonly allowedExtensions = [".pdf", ".gpx"];

    uploadFile(event: any, file: any) {
        const input = event.target;
        if (input.files && input.files.length > 0) {
            const file = input.files[0];
            const fileName = file.name.toLowerCase();

            const allowedExt = this.allowedExtensions.some((ext) =>
                fileName.endsWith(ext),
            );
            const allowedType = this.allowedTypes.includes(file.type);

            if (!allowedExt && !allowedType) {
                const message = this.translateService.instant(
                    "modules.Booking.views.SupplierDataDetails.onlyPdfOrGpxAllowed",
                );
                this.$notificationService.notify(
                    new Notification(
                        `<ul><li>${message}<li></ul>`,
                        "error",
                        10000,
                    ),
                );
                input.value = "";
                return;
            }
        }

        const url = `${
            environment.getDataProviders()["SupplierAppProvider"].serviceUri
        }/web/pdo/SupplierAppService/FileManager?id=${file.DocumentID}`;
        if (event.target.files && event.target.files.length > 0) {
            let formData = new FormData();
            formData.append(
                "requestDetails",
                `entity=booking;BookID=${this.BookID}`,
            );

            for (const droppedFile of event.target.files) {
                formData.append("file", droppedFile);
            }

            this.http
                .post(url, formData, { withCredentials: true })
                .subscribe((response) => {
                    this.getFiles();
                });
        }
    }

    close() {
        this.showFiles = false;
    }

    downloadFile(file: any) {
        if (file.DocumentPath === "") {
            return;
        }
        const url = `${
            environment.getDataProviders()["SupplierAppProvider"].serviceUri
        }/web/pdo/SupplierAppService/FileManager?FileId=${file.DocumentID}`;
        this.http
            .get(url, { withCredentials: true, responseType: "blob" })
            .subscribe((response) => {
                this.saveFile(response, file.DocumentName);
            });
    }

    approveRequest() {
        const url = `${
            environment.getDataProviders()["SupplierAppProvider"].serviceUri
        }/web/pdo/SupplierAppService/SupplierBookingDetailBusinessEntity/AcceptOnRequest`;
        let data = [];
        this.http
            .put(
                url,
                {
                    dsSupplierBookingDetail: this.dsSupplierBookingDetail,
                },
                { withCredentials: true },
            )
            .subscribe(async (response) => {
                await this.readData();
            });
    }

    closeDeclineDialog() {
        this.declineRequestOpened = false;
        this.DeclineComment = "";
    }

    declineOpen() {
        this.declineRequestOpened = true;
        this.DeclineComment = "";
    }

    declineRequest() {
        const url = `${
            environment.getDataProviders()["SupplierAppProvider"].serviceUri
        }/web/pdo/SupplierAppService/SupplierBookingDetailBusinessEntity/DeclineOnRequest`;
        let data = [];
        this.http
            .put(
                url,
                {
                    dsSupplierBookingDetail: {
                        ...this.dsSupplierBookingDetail,
                        ttSupplierBooking:
                            this.dsSupplierBookingDetail.ttSupplierBooking.map(
                                (book: any) => {
                                    return {
                                        ...book,
                                        BookingComment: this.DeclineComment,
                                    };
                                },
                            ),
                    },
                },
                { withCredentials: true },
            )
            .subscribe(async (response) => {
                this.closeDeclineDialog();
                await this.readData();
            });
    }

    saveFile(blob: any, fileName: string): void {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        link.remove();

        setTimeout(() => URL.revokeObjectURL(link.href), 1000);
    }

    removeFile(event: MouseEvent, file: any): void {
        event.stopPropagation();
        const url = `${
            environment.getDataProviders()["SupplierAppProvider"].serviceUri
        }/web/pdo/SupplierAppService/SupplierBookingDetailBusinessEntity/RemoveTravelDocument`;
        this.http
            .put(
                url,
                {
                    travelDocumentId: file.DocumentID,
                    bookId: file.BookingNr,
                },
                { withCredentials: true },
            )
            .subscribe(async (response) => {
                file.DocumentName = "";
                file.DocumentPath = "";
            });
    }

    public approveRequestOneSegment(event: { item: any }) {
        const jsdo = new progress.data.JSDO(
            "SupplierBookingDetailBusinessEntity",
        );

        jsdo.invoke("ApproveOnRequestOneSegment", {
            BookID: event.item.BookID,
            SegmentID: event.item.SegmentID,
            BookingStatus: event.item.BookingStatus,
            ExternalBookID: event.item.ExternalBookID,
        }).then(
            () => {
                this.readData();
            },
            (errorResponse) => {
                alert(errorResponse);
            },
        );
    }

    public declineRequestOneSegment() {
        const jsdo = new progress.data.JSDO(
            "SupplierBookingDetailBusinessEntity",
        );

        jsdo.invoke("DeclineOnRequestOneSegment", {
            BookID: this.selectedSegment.BookID,
            SegmentID: this.selectedSegment.SegmentID,
            BookingStatus: this.selectedSegment.BookingStatus,
            DeclineComment: this.declineOneSegmentComment,
        }).then(
            () => {
                this.readData();
                this.closeDialog();
            },
            (errorResponse) => {
                alert(errorResponse);
            },
        );
    }

    onDeclineOpen(event: { selectedSegment: any }) {
        this.declineRequestOneSegmentOpened = true;
        this.selectedSegment = event.selectedSegment;
    }

    public closeDialog() {
        this.declineRequestOneSegmentOpened = false;
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/modules/booking/supplier-data-details/supplier-data-details.view.component.ts